import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const lmAppsNameApi = createApi({
  reducerPath: 'lmAppsNameApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: [
    'AppName', 
  ],
  endpoints: builder => ({
    getAppName: builder.query({
      query: (params) => ({
        url: `/links/apps/`,
        params,
      }),
      providesTags: ['AppName'],
    }),
    createAppName: builder.mutation({
      query: (data) => ({
        url: '/links/apps/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['AppName'],
    }),
    getAppNameById: builder.query({
      query: (id) => `/links/apps/${id}`,
      providesTags: ['AppName'],
    }),
    updateAppName: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/apps/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['AppName'],
    }),
    
    
  }),
});

export const {
  useGetAppNameQuery,
  useLazyGetAppNameQuery,
  useCreateAppNameMutation,
  useUpdateAppNameMutation,
  useGetAppNameByIdQuery,
} = lmAppsNameApi;
